import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'page1',
    component: () => import("@/views/Page1.vue")
  },
  {
    path: '/upload-video',
    name: 'page2',
    component: () => import("@/views/PageWithUpload.vue")
  },
  {
    path: '/your-code',
    name: 'page3',
    component: () => import("@/views/PageWithCode.vue")
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
